import { Landmark, ExternalLink } from "lucide-react";
import { SectionCard } from "@/components/report/SectionCard";
import { fmtDate } from "@/lib/permitcheck";
import { useLang } from "@/lib/i18n";

export const OfficialSources = ({ report, lang }) => {
  const { t } = useLang();
  const sources = report.official_sources || report.sources || [];

  return (
    <SectionCard icon={Landmark} title={t("sec.sources")} testid="section-sources">
      <ul className="space-y-2.5">
        {sources.map((s, i) => (
          <li key={i} data-testid="official-source-item" className="rounded-lg border border-border bg-secondary/40 p-3">
            <p className="text-sm font-semibold text-foreground">{s.agency}</p>
            <p className="text-xs text-muted-foreground">{s.service}</p>
            {s.endpoint && (
              <a
                href={`${s.endpoint}?f=json`}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-1 flex items-start gap-1 break-all font-mono text-[10px] text-primary hover:underline"
              >
                <ExternalLink className="mt-0.5 h-3 w-3 shrink-0" />
                {s.endpoint}
              </a>
            )}
            {s.retrieved_at && (
              <p className="mt-1 font-mono text-[10px] text-muted-foreground">
                {t("src.retrieved")} {fmtDate(s.retrieved_at, lang)}
              </p>
            )}
          </li>
        ))}
      </ul>
    </SectionCard>
  );
};
